import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_ERROR, AUTH_CHECK } from 'react-admin';
import { GET_PROFILE, UPLOAD_SUCCESS } from './actions'
import { FEATHERS_HOST } from './config'
import { postData } from './utility'
import jwtDecode from 'jwt-decode'

export default (type, params) => {
    // called when the user attempts to log in
  if (type === AUTH_LOGIN) {
    console.log(AUTH_LOGIN)
      const { username, password } = params;
      const email = username
      const strategy = 'local';
      const request = new Request(`${FEATHERS_HOST}/authentication/`, {
        method: 'POST',
        body: JSON.stringify({ strategy, email, password }),
        headers: new Headers({ 'Content-Type': 'application/json' }),
      })
      return fetch(request)
        .then(response => {
          if (response.status < 200 || response.status >= 300) {
            throw new Error(response.statusText);
          }
          return response.json();
        })
        .then(({ accessToken }) => {
          console.log(jwtDecode, jwtDecode(accessToken))
          const profile = jwtDecode(accessToken)
          localStorage.setItem('token', accessToken)
          localStorage.setItem('accessToken', accessToken)
          localStorage.setItem('profile', JSON.stringify(profile))
        });
    }
    // called when the user clicks on the logout button
  if (type === AUTH_LOGOUT) {
    console.log(AUTH_LOGOUT)
        localStorage.removeItem('profile');
    localStorage.removeItem('token');
    localStorage.removeItem('accessToken');
        return Promise.resolve();
    }
    // called when the API returns an error
  if (type === AUTH_ERROR) {
    console.log(AUTH_ERROR)
        const { status } = params;
        if (status === 401 || status === 403) {
            localStorage.removeItem('username');
          localStorage.removeItem('token');
          localStorage.removeItem('accessToken');
            return Promise.reject();
        }
        return Promise.resolve();
    }
    // called when the user navigates to a new location
  if (type === AUTH_CHECK) {
    console.log(AUTH_CHECK)
    const token = localStorage.getItem('token')
    if (localStorage.getItem('token')) {
      console.log('token found')
      console.log(token)
      return Promise.resolve(token)
    } else {
      console.log('token not found')
      return Promise.reject()
    }
        // return localStorage.getItem('token')
        //     ? Promise.resolve()
        //     : Promise.reject();
  }

  if (type === GET_PROFILE) {
    console.log(GET_PROFILE)
    const profile = JSON.parse(localStorage.getItem('profile'))
    console.log(profile)
    return localStorage.getItem('profile')
      ? Promise.resolve(profile)
      : Promise.reject();
  }

  if (type === UPLOAD_SUCCESS) {
    console.log(UPLOAD_SUCCESS)
    const host = `${FEATHERS_HOST}/files/`
    params.forEach(item => {
      const { userId, email } = item.meta

      const payload = {
        ...item,
        userId,
        email
      }
      console.log(payload)
      postData(host, payload)
        .then(data => console.log(JSON.stringify(data))) // JSON-string from `response.json()` call
        .catch(error => console.error(error));
    })

    return Promise.resolve()
  }
  console.log('Unknown auth type', type)
  return Promise.reject('Unknown method');
};



// WEBPACK FOOTER //
// ./src/authProvider.js